import { Navigate, useParams } from 'react-router-dom';
import { validate as isValidUUID } from 'uuid';

import useEnv from '@zenbusiness/application-commons-env';

export default function ValidateEntityUuid({ children }) {
  const { businessEntityUuid } = useParams();

  const { PARENT_SEGMENT } = useEnv();

  if (businessEntityUuid && !isValidUUID(businessEntityUuid)) {
    return <Navigate to={PARENT_SEGMENT} />;
  }

  return children;
}
